module.exports = __webpack_public_path__ + "media/images/ohap_my apps_share-398f158d48f2275f80f9ef4804547a67.png";